import { gql } from '@apollo/client';

export const TIMEZONES_LIST = gql`
  query timezonesList {
    timezonesList {
      unix
      group
      keep
      label
    }
  }
`;

export const TIMEZONE_NAME = gql`
  query timezoneName($unix: String!) {
    timezoneName(unix: $unix)
  }
`;
